import getFormatMessage from '../../../locales/get-format-message';
import { ConsumeCostType } from '../../../model/billing-center';

export const renderFeeType = (type: ConsumeCostType) => {
  let text = '';

  switch (type) {
    case ConsumeCostType.FREEZE:
      text = getFormatMessage('transaction_type_freeze');
      break;
    case ConsumeCostType.POSTPAID:
      text = getFormatMessage('transaction_type_post_paid');
      break;
    case ConsumeCostType.PREPAID:
      text = getFormatMessage('transaction_type_pre_paid');
      break;
    case ConsumeCostType.DRAW:
      text = getFormatMessage('transaction_type_withdrawal');
      break;
    default:
      text = ''; // 默认情况
      break;
  }

  return text;
};
